var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.497,
    height: 24.496,
    viewBox: "0 0 24.497 24.496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M395.532,727.418a1.44,1.44,0,1,0,1.441,1.44A1.44,1.44,0,0,0,395.532,727.418Zm-6.4,1.847a6.049,6.049,0,1,0,6.05,6.049A6.056,6.056,0,0,0,389.13,729.264Zm0,9.924a3.875,3.875,0,1,1,3.875-3.875A3.88,3.88,0,0,1,389.13,739.189Zm12.207-8.9a7.379,7.379,0,0,0-7.379-7.379h-9.738a7.379,7.379,0,0,0-7.379,7.379v9.74a7.378,7.378,0,0,0,7.379,7.378h9.738a7.378,7.378,0,0,0,7.379-7.378Zm-2.311,9.74a5.067,5.067,0,0,1-5.068,5.067h-9.738a5.068,5.068,0,0,1-5.068-5.067v-9.74a5.068,5.068,0,0,1,5.068-5.068h9.738a5.068,5.068,0,0,1,5.068,5.068Z",
    transform: "translate(-376.84 -722.907)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.091bd6d6aa396dfe76b5964c2d042648.svg";
export { ForwardRef as ReactComponent };